import { createRoot } from "react-dom/client";
import { LandingPage } from "./LandingPage.js";
import "./landing.css";

createRoot(document.getElementById("root")!).render(<LandingPage />);
